export default function setDescriptionErrorAction(descriptionError) {
    return {
        type: 'SET_DESCRIPTION_ERR',
        payload: descriptionError
    }
}